import { Link } from 'react-router-dom'

import { ReactComponent as HomeSVG } from '../../Assets/home.svg'
import { ReactComponent as AskQuestionMarkSVG } from '../../Assets/ask-question-mark.svg'
import { ReactComponent as TelescopeSVG } from '../../Assets/telescope.svg'
import { ReactComponent as TvSVG } from '../../Assets/tv.svg'
import { ReactComponent as SchoolSVG } from '../../Assets/school.svg'
import { ReactComponent as CommitSVG } from '../../Assets/commit.svg'
import { ReactComponent as TagsSVG } from '../../Assets/tags.svg'


function SideNav() {
    return <>
        <nav className="sidenav hide-sm">
            <modal-button selector="algolia-search">
                <span className="item">
                    <TelescopeSVG />
                    <span className="item-label tag tag-contrast tag-sm">Search</span>
                </span>
            </modal-button>

            <Item Icon={HomeSVG} title="Home" to="/" />
            <Item Icon={AskQuestionMarkSVG} title="Questions" to="/questions" />
            <Item Icon={TagsSVG} title="Tags" to="/tags" />
            <Item Icon={TvSVG} title="video lessons" to="/video-lessons" />
            <Item Icon={SchoolSVG} title="courses" to="/courses" />
            <Item Icon={CommitSVG} title="quick snippets" to="/quick-snippets" />
        </nav>
    </>
}

function Item({ Icon, title, to }) {
    return <>
        <Link className="item" to={to}>
            <Icon />
            <span className="item-label tag tag-contrast tag-sm">{title}</span>
        </Link>
    </>
}


export default SideNav
